import {
	ConversionUnitsResponse,
	ConversionUnitsPayload,
	ConversionAngularSpeedPayload,
	ConversionLinearSpeedPayload
} from '../../../components/bearing-search/types/types';

import { trackUnitConversionResults } from '../../utils/analytics';

export const mapConversionAnalyicsData = (category: string, conversionPayload: ConversionUnitsPayload | ConversionAngularSpeedPayload | ConversionLinearSpeedPayload, conversionResponse: ConversionUnitsResponse): void => {
	let targetData;

	if ('unitConversionInputs' in conversionPayload) {
		targetData = conversionPayload.unitConversionInputs[0];
	} else if ('angularSpeedInputs' in conversionPayload) {
		targetData = conversionPayload.angularSpeedInputs[0];
	} else if ('linearSpeedData' in conversionPayload) {
		targetData = conversionPayload.linearSpeedData[0];
	}

	const analyticsData: { category: string; precision?: number, exponent?: boolean } = {
		category,
		...targetData,
	};

	if (analyticsData.precision === 4) {
		delete analyticsData.precision;
	}

	if (!analyticsData.exponent) {
		delete analyticsData.exponent;
	}

	const numberOfResults = conversionResponse ? 1 : 0;
	trackUnitConversionResults('conversionTool', analyticsData, numberOfResults);
};
